import { DECIMAL_PLACES, NA_DEFAULT_CURRENCY } from "../common/Constants";
import { NOTNULL_OR_NOTUNDEFINED } from "./EmpUtil";

export function formatPriceValue(value, fallback) {
  const defaultCurrency = NA_DEFAULT_CURRENCY;

  if (NOTNULL_OR_NOTUNDEFINED(value)) {
    value = Number(parseFloat(value).toFixed(DECIMAL_PLACES)).toLocaleString(
      "en",
      { minimumFractionDigits: DECIMAL_PLACES }
    );

    value = value.toString();
    value =
      value.charAt(0) === "+" || value.charAt(0) === "-"
        ? value.charAt(0).concat(defaultCurrency, value.substr(1))
        : defaultCurrency.concat(value);
  } else {
    if (fallback) value = fallback;
    else value = "--";
  }
  return value;
}

export function formatEUPriceValue(value, currency, fallback, hideComma) {
  if (NOTNULL_OR_NOTUNDEFINED(value)) {
    value = Number(parseFloat(value).toFixed(DECIMAL_PLACES)).toLocaleString(
      "en",
      { minimumFractionDigits: DECIMAL_PLACES }
    );
    if (hideComma) value = value.replace(",", "");

    value = value.toString();
    value =
      value.charAt(0) === "+" || value.charAt(0) === "-"
        ? value.charAt(0).concat(currency, value.substr(1))
        : currency.concat(value);
  } else {
    if (fallback) value = fallback;
    else value = "--";
  }
  return value;
}
